import React from 'react';
import {
    MainContainer,
    OptionTitle,
    EditButtonContainer,
    EditButtonStyled,
    CollapsableCardMain
} from './CollapsableCard.styled';
import {
    CollapsableCardRowHeader,
    CollapsableCardTitle,
    CollapsableCardImageContainer,
} from 'src/styles/CommonStyles.styled';
import DownArrowFilter from 'src/assets/images/DownArrowFilter.svg';
import Edit from 'src/assets/images/Edit.svg';
import { useSelector } from 'react-redux';
import { PRIMARY_FONT_COLOR, SMALL_TEXT_PX, FONT_FAMILY_DEMI,  BASE_TEXT_PX,
    } from 'src/styles/fonts/MCFontConstants';

const CollapsableCard = ({
    title,
    optionTitle,
    onClick,
    isExpanded,
    children,
    margin,
    editButton,
    editPage,
    borderRadius,
    boxShadow,
    padding,
    width,
    mobileWidth,
    mbPadding,
    mbHeaderWidth,
    mbHeaderMargin,
    mbMarginBottom,
    mobileMargin,
    headerMargin,
    cursor,
    fontWeight,
    noCardData,
    optionValue,
    paddingRight,
    fontSizeMobile,
    fontSize,
    CollapsableCardIconWidthHeight,
    CollapsableIconMarginRight,
    isConsignment,
    consignmentAdd,
    isTemplate,
    collapsableCardClassName,
    showAstrisk,
    marginBottom,
    ipadMargin,
    reportUsagePatientDetails,
    segmentTitle,
    borderBottomWidth,
    borderBottom,
    segmentFontWeight,
    titleCursor,
    itemListViewClick,
    inYourCartClick,
    mobileCardWidth,
    mediumDeviceWidth,
    isFromSurgeryTemplate = false,
    marginLeft,
    id,
    showContentOnCollapsed,
    mainContainerMarginBottom,
}) => {
    // const dispatch = useDispatch();
    const isItemListClicked = useSelector(state => state.surgeryReducer?.isItemListClicked ?? false);
    const isCondensedView = useSelector((state) => state.loginReducer.isCondensedView);

 
    return (
        <>
            <MainContainer
                id={id}
                mobileCardWidth={mobileCardWidth}
                margin={margin}
                mobileMargin={mobileMargin}
                padding={padding}
                borderRadius={!isCondensedView ? borderRadius : '6px'}
                boxShadow={boxShadow}
                width={width}
                mobileWidth={mobileWidth}
                mbPadding={mbPadding}
                paddingRight={paddingRight}
                className={collapsableCardClassName}
                ipadMargin={ipadMargin}
                marginBottom={marginBottom}
                mbMarginBottom={mbMarginBottom}
                mediumDeviceWidth={mediumDeviceWidth}
                mainContainerMarginBottom={mainContainerMarginBottom}
            >
                <CollapsableCardRowHeader
                    // onClick={onClick}
                   onClick={segmentTitle ? () => {} : onClick}
                    isExpanded={isExpanded}
                    mbHeaderWidth={mbHeaderWidth}
                    mbHeaderMargin={mbHeaderMargin}
                    mbMarginBottom={mbMarginBottom}
                    pointerEvents={noCardData && 'none'}
                    headerMargin={headerMargin}
                    isConsignment={isConsignment}
                    consignmentAdd={consignmentAdd}
                    marginBottom={marginBottom}
                    isTemplate={isCondensedView && isTemplate}
                >
                    <CollapsableCardMain>
                        <CollapsableCardTitle
                            fontSize={fontSize || BASE_TEXT_PX}
                            fontSizeMobile={fontSizeMobile}
                            fontWeight={fontWeight}
                            fontFamily={FONT_FAMILY_DEMI}
                            showAstrisk={showAstrisk}
                            fontColor={PRIMARY_FONT_COLOR}
                            borderBottomWidth={
                                !isItemListClicked && borderBottomWidth
                            }
                            marginLeft={marginLeft}
                            borderBottom={!isItemListClicked && borderBottom}
                            onClick={segmentTitle ? inYourCartClick : () => {}}
                            cursor={titleCursor}
                        >
                            {title}
                            &nbsp;
                            <OptionTitle optionValue={optionValue}>
                                {optionTitle}
                            </OptionTitle>
                        </CollapsableCardTitle>
                        {segmentTitle && (
                            <CollapsableCardTitle
                                fontSize={BASE_TEXT_PX}
                                fontSizeMobile={SMALL_TEXT_PX}
                                fontWeight={segmentFontWeight}
                                fontFamily={FONT_FAMILY_DEMI}
                                showAstrisk={showAstrisk}
                                fontColor={PRIMARY_FONT_COLOR}
                                borderBottomWidth={
                                    isItemListClicked && borderBottomWidth
                                }
                                borderBottom={isItemListClicked && borderBottom}
                                onClick={itemListViewClick}
                                marginLeft={'1%'}
                                cursor={titleCursor}
                            >
                                {segmentTitle}
                            </CollapsableCardTitle>
                        )}
                    </CollapsableCardMain>

                    <EditButtonContainer 
                    >
                        <EditButtonStyled
                            editButton={editButton}
                            id = 'edit-button-collapsablecard'
                            onClick={() => editPage()}
                            editButtonPointerEvents={noCardData && 'all'}
                            marginRight={noCardData && '30px'}
                        >
                            <img
                                style={{ padding: '2px' }}
                                src={Edit}
                                alt="edit-button"
                                height={'auto'}
                                width={'auto'}
                            />
                        </EditButtonStyled>
                        <CollapsableCardImageContainer
                            id = 'down-arrow-collapsablecard'
                            onClick={segmentTitle ? onClick : () => {}}
                            src={DownArrowFilter}
                            alt="down-arrow"
                            isExpanded={isExpanded}
                            marginRight={isFromSurgeryTemplate && '13px'}
                            cursor={cursor}
                            height={
                                CollapsableCardIconWidthHeight
                                    ? CollapsableCardIconWidthHeight
                                    : 'auto'
                            }
                            width={
                                CollapsableCardIconWidthHeight
                                    ? CollapsableCardIconWidthHeight
                                    : 'auto'
                            }
                            display={
                                (reportUsagePatientDetails?.length < 0 &&
                                    'none') ||
                                (noCardData && 'none')
                            }
                            mbMargin={CollapsableIconMarginRight}
                            mdMargin={CollapsableIconMarginRight}
                        />
                    </EditButtonContainer>
                </CollapsableCardRowHeader>
                {isExpanded && children}
                {(!isExpanded && showContentOnCollapsed) && children}
            </MainContainer>
        </>
    );
};
export default CollapsableCard;